import { compose, withProps, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { actions as addressActions } from 'state/addresses';

import AddressDeleteModal from 'components/AddressDeleteModal/styled';

const enhance = compose(
  withTranslation('AddressFormModal'),
  connect(() => ({}), {
    deleteAddress: addressActions.submitDeleteAddress,
  }),
  withProps(({ address: { company_name, label, id } }) => ({
    id,
    company_name,
    label,
  })),
  withHandlers({
    handleClose:
      ({ onClose }) =>
      () => {
        onClose();
      },
    handleDelete:
      ({ onClose, deleteAddress, id }) =>
      () => {
        deleteAddress({ addressId: id, onClose });
      },
  })
);
export default enhance(AddressDeleteModal);
